module.exports = __webpack_public_path__ + "img/page_05.af9e4ce6.jpg";